export enum EmailTemplateTypes {
  EVENT = 'EVENT',
  LOYALTY_OFFER = 'LOYALTY_OFFER',
  MESSAGE = 'MESSAGE',
  OFFER = 'OFFER',
}

export enum EventEmailTemplateTypes {
  ADMIN_PASSWORD_RESET = 'ADMIN_PASSWORD_RESET',
  COMP_GIFT_CARD_FAILED = 'COMP_GIFT_CARD_FAILED',
  EMAIL_GIFTCARD_ADD_VALUE = 'EMAIL_GIFTCARD_ADD_VALUE',
  EMAIL_GIFTCARD_ADD_VALUE_RECEIPT = 'EMAIL_GIFTCARD_ADD_VALUE_RECEIPT',
  EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_FAILED = 'EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_FAILED',
  EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_SUCCESS = 'EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_SUCCESS',
  EMAIL_GIFTCARD_PURCHASE_RECEIPT = 'EMAIL_GIFTCARD_PURCHASE_RECEIPT',
  GIFTCARD_PURCHASE = 'GIFTCARD_PURCHASE',
  GIFT_CARD_EMAIL_RECEIPT = 'GIFT_CARD_EMAIL_RECEIPT',
  GIFT_CARD_FAILED = 'GIFT_CARD_FAILED',
  OFFER_DISTRIBUTION = 'OFFER_DISTRIBUTION',
  ORDER_FAILURE_NOTIFIER = 'ORDER_FAILURE_NOTIFIER',
  POINTS_EXPIRY_NOTIFICATION = 'POINTS_EXPIRY_NOTIFICATION',
  TABLET_APP_MESSAGES = 'TABLET_APP_MESSAGES',
  USER_PASSWORD_RESET = 'USER_PASSWORD_RESET',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
}
